<div class="info-card">
  <div class="label">{{ label | translate }}</div>
  <div class="value">{{ value }}</div>
</div>
